import { Link } from "react-router-dom";

export const LOGO_FULL = "/brand/salimbado-logo-full.webp";
export const LOGO_MARK = "/brand/salimbado-logo-mark.webp";

// compact: mark + wordmark (headers, sidebars); full: official logo with text (login, hero)
export const Logo = ({ light = false, to = "/", testid = "brand-logo", variant = "compact", className = "" }) => {
  if (variant === "full")
    return (
      <Link to={to} className={`inline-block shrink-0 rounded-2xl bg-white/95 p-3 shadow-sm ring-1 ring-emerald-900/10 ${className}`} data-testid={testid}>
        <img src={LOGO_FULL} alt="Salimbado Farm by PT SJI" width="640" height="635" className="block h-auto w-full object-contain" />
      </Link>
    );
  return (
    <Link to={to} className={`flex items-center gap-2.5 shrink-0 ${className}`} data-testid={testid}>
      <span className={`grid place-items-center h-11 w-11 rounded-xl bg-white p-0.5 shadow-sm ${light ? "ring-1 ring-white/40" : "ring-1 ring-emerald-900/10"}`}>
        <img src={LOGO_MARK} alt="" width="256" height="256" className="h-full w-full object-contain" />
      </span>
      <span className="leading-tight">
        <span className={`block text-[15px] font-extrabold tracking-wide ${light ? "text-white" : "text-slate-900"}`}>
          SALIMBADO <span className={light ? "text-emerald-200" : "text-emerald-700"}>FARM</span>
        </span>
        <span className={`block text-[10px] font-semibold uppercase tracking-[0.22em] ${light ? "text-emerald-100/80" : "text-emerald-700"}`}>
          by PT SJI
        </span>
      </span>
    </Link>
  );
};
